import React, { useState, useContext } from "react";
import { Row, Col, Input, Radio, AutoComplete, Typography } from "antd";
import { BusinessContext } from "../../context/BusinessContext";
import FeatureFoodItems from "../features/Menu/FeatureFoodItems";
import { Helmet } from 'react-helmet';
import BannerSlider from "../BannerSlider/BannerSlider";
import TopReviews from "../Reviews/TopReviews";
import HowItWorks from "../HowItWorks";
import Openinghours from "../Openinghours/Openinghours";
import SpecialMeals from "../SpecialMeals";
import PopularCategories from "../PopularCategories";
import OurServicesList from "../OurServices";
import "../../assets/css/Home.css";
import "../../assets/css/Font.css";
import AboutUs from "../About/About";
import Ticker from "../Ticker/Ticker";
import UKPostcodeSearch from "./UKPostcodeSearch";
import DirectOrderSearch from "./DirectOrderSearch";
const { Title } = Typography;

const Home = () => {
  const { businessInfo, loading } = useContext(BusinessContext);
  console.log(businessInfo?.businessInfo?.[0]?.portal_info?.[0]
    ?.opening_hours_section_enable);
  return (
    <>
   <Helmet>
  {/* Title */}
  <title>Chilli Bites | Indian Street Food & Takeaway in Burgess Hill</title>
  <meta
    name="description"
    content="Craving authentic Indian street food in Burgess Hill? Chilli Bites offers delicious samosas, curries, naan, and more for takeaway or dine-in. Order online today!"
  />
  <meta
    name="keywords"
    content="Indian street food Burgess Hill, Indian takeaway Burgess Hill, Chilli Bites Burgess Hill, Indian restaurant Burgess Hill, samosas, curry, naan"
  />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://chillibitesuk.com/" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Chilli Bites | Indian Street Food & Takeaway in Burgess Hill"
  />
  <meta
    property="og:description"
    content="Delicious Indian street food in Burgess Hill! Enjoy samosas, curries, naan, and more at Chilli Bites. Order online or visit us today."
  />
  <meta
    property="og:image"
    content="https://chillibitesuk.com/images/og-image.jpg"
  />
  <meta property="og:url" content="https://chillibitesuk.com/" />
  <meta property="og:type" content="restaurant" />

  {/* Twitter Card Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Chilli Bites | Indian Street Food & Takeaway in Burgess Hill"
  />
  <meta
    name="twitter:description"
    content="Enjoy authentic Indian street food at Chilli Bites in Burgess Hill — samosas, curries, naan, and more. Order online or visit us today!"
  />
  <meta
    name="twitter:image"
    content="https://chillibitesuk.com/images/og-image.jpg"
  />

  {/* Structured Data (JSON-LD) for SEO */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "Restaurant",
        "name": "Chilli Bites",
        "description": "Chilli Bites offers authentic Indian street food and takeaway in Burgess Hill. Enjoy samosas, curries, naan, and more, prepared with fresh ingredients.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "31 Church Road",
          "addressLocality": "Burgess Hill",
          "addressRegion": "West Sussex",
          "postalCode": "RH15 9BB",
          "addressCountry": "UK"
        },
        "telephone": "01444 235588",
        "url": "https://chillibitesuk.com",
        "image": "https://chillibitesuk.com/images/og-image.jpg",
        "menu": "https://chillibitesuk.com/menu",
        "priceRange": "££",
        "servesCuisine": "Indian",
        "paymentAccepted": "Cash, Credit Card, Debit Card",
        "sameAs": [
          "https://www.facebook.com/chillibitesuk",
          "https://www.instagram.com/chillibitesuk"
        ]
      }
    `}
  </script>
</Helmet>

     <Ticker />
      <Row className="searchSection">
        <Col
          xs={24}
          sm={24}
          md={12}
          xl={12}
          xxl={12}
          style={{ paddingLeft: "0px", paddingRight: "0px" }}
        >
          <DirectOrderSearch />
          {/* <UKPostcodeSearch /> */}
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          xl={12}
          xxl={12}
          style={{ paddingLeft: "0px", paddingRight: "0px" }}
        >
          <BannerSlider /> {/* Your slider component */}
        </Col>
      </Row>
     
      {businessInfo?.businessInfo?.[0]?.portal_info?.[0]
        ?.how_it_work_section_enable === 1 && <HowItWorks />}

      {businessInfo?.businessInfo?.[0]?.portal_info?.[0]
        ?.about_home_section_enable === 1 && <AboutUs />}

      {businessInfo?.businessInfo?.[0]?.portal_info?.[0]
        ?.popular_food_items_section_enable === 1 && <SpecialMeals />}

      {businessInfo?.businessInfo?.[0]?.portal_info?.[0]
        ?.popular_categories_section_enable === 1 && <PopularCategories />}

      {businessInfo?.businessInfo?.[0]?.portal_info?.[0]
        ?.opening_hours_section_enable === 1 && <Openinghours />}

      {businessInfo?.businessInfo?.[0]?.portal_info?.[0]
        ?.restaurant_service_section_enable === 1 && <OurServicesList />}

      {businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.review_enable ===
        1 && <TopReviews />}
    </>
  );
};

export default Home;
